export const QR_INNOVATIVE_SWING_EXP_FLAG = 'pen-5713_v2'
export const QRISC_QUERY_PARAM = 'qrisc'

// Variant 1: Scrolly-Telling
export const VARIANT_1_TARGET_COURSE_COUNT = 3

export const SCREEN_IDS = {
  INITIAL: 'initial',
  TRAILER: 'trailer',
  TESTIMONIAL: 'testimonial',
  AUDIO_FIRST: 'audio-first',
  VALUE_PROPS: 'value-props',
} as const

export const SCREEN_NAVIGATION_ORDER = [
  SCREEN_IDS.INITIAL,
  SCREEN_IDS.TRAILER,
  SCREEN_IDS.TESTIMONIAL,
  SCREEN_IDS.AUDIO_FIRST,
  SCREEN_IDS.VALUE_PROPS,
] as const

// Variant 2: Watchlist
export const VARIANT_2_TARGET_COURSE_COUNT = 10

export const WATCHLIST_SCREEN_IDS = {
  INITIAL: 'initial',
  BUILD: 'build',
  REVIEW: 'review',
} as const

export const WATCHLIST_NAVIGATION_ORDER = [
  WATCHLIST_SCREEN_IDS.INITIAL,
  WATCHLIST_SCREEN_IDS.BUILD,
  WATCHLIST_SCREEN_IDS.REVIEW,
] as const

export const WATCHLIST_LOADING_TIMEOUT = 6000
export const WATCHLIST_CARD_TRANSITION_DURATION = 350
export const WATCHLIST_ITEM_MESSAGE_DURATION = 600
export const WATCHLIST_MAX_CARDS = 3
export const WATCHLIST_CARD_STACK_SEPARATION = 12
export const WATCHLIST_CARD_SWIPE_DISTANCE = 600
export const WATCHLIST_CARD_ROTATION_DEGREES = 20

// Watchlist Review Carousel Configuration
export const WATCHLIST_CAROUSEL_CONFIG = {
  SCREEN_WIDTH_PERCENTAGE: 0.75, // Center card takes 75% of screen width
  MAX_CARD_WIDTH: 416, // Maximum card width in pixels
  SNAP_DEBOUNCE_MS: 150, // Debounce time for snap-to-center
  SIDE_CARD_SCALE: 0.9, // Scale factor for non-center cards (90% of center card size)
  SIDE_CARD_OPACITY: 0.9, // Opacity for non-center cards on mobile
} as const

export const EVENTS = {
  ACTIONS: {
    BACK: 'back',
    NEXT: 'next',
    CAROUSEL_NEXT: 'Carousel Next',
    CAROUSEL_BACK: 'Carousel Back',
    CLICK: 'click',
    PLAY_TRAILER: 'Play Trailer',
    PLAY_SAMPLE: 'Play Sample',
    WATCHLIST_ADD: 'Watchlist Item Added',
    WATCHLIST_SKIP: 'Watchlist Item Skipped',
    WATCH_TRAILER: 'Watch Trailer',
    TILE_CLICK: 'Tile Click',
    TRAILER_CLOSED: 'Trailer Modal Closed',
    TRAILER_OPEN: 'Trailer Modal Open',
  },
  LOCATIONS: {
    INNOVATIVE_PLANS_PRIMER: 'innovative-plans-primer',
  },
  QR_SCREEN_VIEWED: 'Quiz Results Screen Viewed',
  QR_PAGE_CLICK: 'Quiz Results Page Click',
  QR_WATCHLIST_COMPLETED: 'Quiz Results Watchlist Completed',
}
